import React from 'react';
import { BookOpenIcon, GiftIcon, LeafIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 strategic bonuses'
}, {
  icon: LeafIcon,
  label: '+300 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and professionals'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-white py-5" aria-label="What the collection includes" data-id="element-216" data-mp="3f4w0k0myvke">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-217" data-mp="8dog0evo5xa4">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-218" data-mp="3ut0yf4s7xnv1">
            <Icon className="h-5 w-5 text-green" aria-hidden="true" data-id="element-219" data-mp="mdpitzvhves8" /> {label}
          </span>)}
      </div>
    </section>;
}